import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { normalizarEmail, validarEmail } from "../../../Utils/validarEmail";

/**
 * Input de e-mail com normalização e validação de formato.
 * value/onChange usam string normalizada (trim, minúsculas, sem espaços).
 * Props: value, onChange, placeholder, id, className, disabled, name, autoComplete, required.
 */
export default function Email({
  value,
  onChange,
  placeholder = "nome@empresa.com.br",
  id,
  className = "form-control",
  disabled,
  name,
  autoComplete = "email",
  required = false,
}) {
  const [touched, setTouched] = useState(false);

  const valorAtual = value ?? "";
  const valorNormalizado = normalizarEmail(valorAtual);
  const isInvalid =
    touched &&
    ((required && !valorNormalizado) ||
      (valorNormalizado.length > 0 && !validarEmail(valorNormalizado)));

  const handleChange = (event) => {
    const semEspacos = event.target.value.replace(/\s/g, "");
    if (onChange) onChange(semEspacos);
  };

  const handleBlur = () => {
    setTouched(true);
    const normalizado = normalizarEmail(valorAtual);
    if (normalizado !== valorAtual && onChange) {
      onChange(normalizado);
    }
  };

  return (
    <Form.Control
      type="email"
      inputMode="email"
      autoComplete={autoComplete}
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
      maxLength={254}
      value={valorAtual}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      className={className}
      id={id}
      name={name}
      disabled={disabled}
      isInvalid={isInvalid}
      aria-invalid={isInvalid}
    />
  );
}
